<!-- Start: Rejwan: 19-06-2025 Reporting -->
<template>
    <div class="">
        <div class="clearfix company-form-container-warapper"> <!-- Mustafijur: 01-06-2026: Removed  company-form-container -->
            <div class="custom-loader-wrapper" v-if="loader">
                <div class="text-center">
                    <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                    <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

                </div>
            </div>

            <!-- Mustafijur: 01-06-2026: Start -->
            <!-- <div class="company-form-container-title-wrapper">
                <div class="col-sm-12 px-3 company-form-box-title">
                    <div class="trustee-nav-first">
                        <div class="trustee-nav-head">PF Advance Applied Members Age Wise Report</div>
                        <div class="trustee-nav-subhead">Select parameters below to generate and download report.</div>
                    </div>
                </div>
            </div>

            <div class="report-button-contents">
                <div class="button_wrapper">
                    <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                </div>
            </div> -->

            <div class="row mt-4 no-margin">
                <div class="ibox col-md-12">
                    <div class="ibox-title dashboard_title px-0">
                        <h4 class="font-regular with-blue-text">Current Selected: <span>PF Advance Applied Members Age Wise Report</span></h4>
                        <h4>Select parameters below to generate and download report.</h4>
                    </div>
                    <div class="ibox-content px-0 trz_ppl_wrapper_2">
                        <div class="d-inline-block">
                            <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mustafijur: 01-06-2026: Ends -->


        </div>
    </div>
</template>

<script>


    export default{

        mounted() {
        },
        props: [],
        components: {

        },
        data(){

            return {

                empty_result : 'Please hold tight! We are preparing the report data for you!',
                loader: false,
                showoverlay : true,
            }
        },
        methods:{
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                let url = ''

                url = this.$api_url + '/pf/report/advance-status';


                let formData = new FormData();

                let currentObj = this;
                this.downloadBlobResponse(
                    axios.post(url, formData, { responseType: 'blob' }),
                    'loader' // your loader key in this component
                );
                return false;
            },
        },
        created: function(){


        },
        computed:
        {

        }
    }
</script>

<!-- End: Rejwan: 19-06-2025 Reporting -->
